import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Row, Col, ListGroup, Card } from 'react-bootstrap';
import { useGetExpenseDetailsQuery } from '../slices/expensesApiSlice';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Meta from '../components/Meta';
import ExpenseCarousel from '../components/ExpenseCarousel';

const ExpenseScreen = () => {
  const { id: expenseId } = useParams();
  const { data: expense, isLoading, error } = useGetExpenseDetailsQuery(expenseId);

  const renderExpenseDetails = () => (
    <>
      <Meta title={expense.date} description={expense.account} />
      <Row>
        <Col md={6}>
          {/* Display expense images using ExpenseCarousel */}
          {expense.images && expense.images.length > 0 ? (
            <ExpenseCarousel images={expense.images} />
          ) : (
            <Message variant="info">No images available for this expense</Message>
          )}
        </Col>
        <Col md={3}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h3>{expense.accountName}</h3>
            </ListGroup.Item>
            <ListGroup.Item>Details: {expense.details}</ListGroup.Item>
            <ListGroup.Item>Amount: {expense.amount}</ListGroup.Item>
            <ListGroup.Item>
              Category: {expense.category}
            </ListGroup.Item>
            <ListGroup.Item>Notes:{expense.notes}</ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={3}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <Row>
                  <Col>Amount:</Col>
                  <Col>
                    <strong>{expense.amount}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>User:</Col>
                  <Col>
                    {expense.username}
                  </Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
          <div className="expense-images mt-3">
                    <h6>Images:</h6>
                    <div className="image-thumbnails">
                      {expense.images?.map((image, index) => (
                        <img
                          key={index}
                          src={image}
                          alt={` ${index + 1}`}
                          className="thumbnail-img"
                          style={{
                            width: '50px',
                            height: '50px',
                            marginRight: '5px',
                            borderRadius: '5px',
                          }}
                        />
                      ))}
                    </div>
                  </div>
        </Col>
      </Row>
    </>
  );

  return (
    <>
      <Link className="btn btn-light my-3" to="/">
        Go Back
      </Link>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">
          {error?.data?.message || error.error}
        </Message>
      ) : (
        renderExpenseDetails()
      )}
    </>
  );
};

export default ExpenseScreen;